export default import.meta.ROLLUP_FILE_URL_pT1Ag$Wa0UafEpxVi_UY7Q